import React from "react";
import HomeCategoryGridData from "./HomeCategoryGridData.json";
const homeCategoryGridData = HomeCategoryGridData;
const HomeCategoryGridView = () => <div id="main" role="main" data-sentry-component="HomeCategoryGridView" data-sentry-source-file="HomeCategoryGridView.tsx">
    <div id="home-category-grid">
      <div className="grid-module">
        <div className="grid-children">
          {homeCategoryGridData.map(category => <div className="grid-item grid-child" key={category.name}>
              <img src={category.image} alt={category.name} />
              <span className="description">
                <a href={category.link} className="header-3">
                  {category.name}
                </a>
                {category.members.map(member => <a href={member.link} key={member.name}>
                    {member.name}
                  </a>)}
              </span>
            </div>)}
        </div>
      </div>
    </div>
  </div>;
export default HomeCategoryGridView;